import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ar from './locales/ar.json';

export const SUPPORTED_LANGUAGES = ['en', 'ar'];
export const DEFAULT_LANGUAGE = 'en';
export const RTL_LANGUAGES = ['ar'];

/** The URL prefix a language lives under. English stays at the root. */
export function languagePrefix(lang) {
  return lang === DEFAULT_LANGUAGE ? '' : `/${lang}`;
}

/**
 * Build an href for `path` in `lang`.
 * localePath('/contact', 'ar') -> '/ar/contact'
 * localePath('/contact', 'en') -> '/contact'
 */
export function localePath(path, lang) {
  const clean = path.startsWith('/') ? path : `/${path}`;
  const prefix = languagePrefix(lang);
  if (clean === '/') return prefix || '/';
  return `${prefix}${clean}`;
}

/** Strip any language prefix from a pathname, returning the canonical path. */
export function stripLanguage(pathname) {
  for (const lang of SUPPORTED_LANGUAGES) {
    if (lang === DEFAULT_LANGUAGE) continue;
    if (pathname === `/${lang}`) return '/';
    if (pathname.startsWith(`/${lang}/`)) return pathname.slice(lang.length + 1);
  }
  return pathname || '/';
}

/** Read the language out of a pathname. */
export function languageFromPath(pathname) {
  for (const lang of SUPPORTED_LANGUAGES) {
    if (lang === DEFAULT_LANGUAGE) continue;
    if (pathname === `/${lang}` || pathname.startsWith(`/${lang}/`)) return lang;
  }
  return DEFAULT_LANGUAGE;
}

export function isRTL(lang) {
  return RTL_LANGUAGES.includes(lang);
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false }, // React already escapes
  react: { useSuspense: false },
});

export default i18n;
